import { slideToggle } from '../helpers';

const details = document.querySelectorAll('details');
details.forEach((detail) => {
	const content = detail.querySelector('.details-content');
	if (content) {
		detail.classList.add('cursor-pointer');
		detail.setAttribute('open', '');
		content.classList.add('hidden');
		detail.addEventListener('click', function (e) {
			e.preventDefault();
			slideToggle(content);
			detail.classList.toggle('open');
		});
	}
});
